import _ from 'lodash'
import { ActionContext } from 'vuex'
import { IState } from '@/store/service/state'
import { commonState } from '../service/state'
import { commonMutations } from '../service/mutations'
import { commonGetters } from '../service/getters'
import { findAll, findByPk, createItem, updateItem, changeDeletionMark, addNewItem, deleteItem, resetState } from '../service/actions'

import BasicObject from '@/dto/RoleGroups.json'
const apiUrl = 'role_groups'

export const state = Object.assign({}, _.cloneDeep(commonState))

export const mutations = { ...commonMutations }

export const actions = {
  async findAll(context: ActionContext<IState, any>, payload: any) {
    return findAll(context, apiUrl, payload)
  },

  async findByPk(context: ActionContext<IState, any>, payload: any) {
    return findByPk(context, apiUrl, payload, itemHundler)
  },

  async create(context: ActionContext<IState, any>, payload: any) {
    return createItem(context, apiUrl, payload)
  },

  async update(context: ActionContext<IState, any>, payload: any) {
    return updateItem(context, apiUrl, payload)
  },

  async delete(context: ActionContext<IState, any>, payload: any) {
    return deleteItem(context, apiUrl, payload)
  },

  async changeDeletionMark(context: ActionContext<IState, any>, payload: any) {
    return changeDeletionMark(context, apiUrl, payload)
  },

  async addNew(context: ActionContext<IState, any>, payload: any) {
    return addNewItem(context, { basicObject: BasicObject }, payload, beforeAddNew)
  },

  async getSelectFields() {
    return [{ key: 'name', label: 'table.name', sortable: true }]
  },
}

function beforeAddNew(viewData: any) {
  viewData.settCurrPage = 1
  viewData.usersCurrPage = 1
  viewData.userSortBy = 'name'
  viewData.userSortDesc = false
  viewData.settSortBy = 'name'
  viewData.settSortDesc = false
  viewData.departmentsCurrPage = 1
  viewData.departmentSortBy = 'name'
  viewData.departmentSortDesc = false
  viewData.currTab = 0
}

function itemHundler(itemData: any) {
  itemData.settCurrPage = 1
  itemData.usersCurrPage = 1
  itemData.userSortBy = 'name'
  itemData.userSortDesc = false
  itemData.settSortBy = 'name'
  itemData.settSortDesc = false
  itemData.departmentsCurrPage = 1
  itemData.departmentSortBy = 'name'
  itemData.departmentSortDesc = false
  itemData.currTab = 0
}

export const getters = { ...commonGetters }
